export default "__VITE_ASSET__CSzG0vtM__"